import React, { useEffect } from "react";
import { Output } from "../../Text";
import {
  SectionHeading,
  Button,
  Paragraph,
  ContentSection,
} from "@vwfs-bronson/bronson-react";
import Icon, { IconSize } from "../../components/Icon";
import { TransactionStatus } from "@bus/models/dist/enums/new/transaction-status.enum";
import { Analytics } from '../../services/analytics';
import { setActualPage, trackInteractionSuccess } from '../page.utils';

export interface CreditResultPageProps {
  creditResult: TransactionStatus;
  onSuccess?: () => void;
  originSystem: string
}

const CreditResultPage = ({
  creditResult,
  onSuccess,
  originSystem
}: CreditResultPageProps) => {
  const wasApproved = creditResult === TransactionStatus.SOFTCREDIT_APPROVED;
  const texts: any =
    wasApproved
      ? "pages.heyCar.creditResult.creditAccpeted"
      : "pages.heyCar.creditResult.creditRefused"

  let defaultTrackingData = {}

  const defaultTrackingDataSuccess = {
    [Analytics.keys.pageName()]: 'Credit check success',
    [Analytics.keys.viewChange()]: 'Credit check success',
  }

  const defaultTrackingDataFailed = {
    [Analytics.keys.pageName()]: 'Credit check failed',
    [Analytics.keys.viewChange()]: 'Credit check failed',
  }

  const setDefaultTrackingData = () => {
    defaultTrackingData = wasApproved 
    ? defaultTrackingDataSuccess
    : defaultTrackingDataFailed
  }

  const setSpecificTrackingData = () => {
    let pageData = {
      [Analytics.keys.eventType(0)]: 'pageView',
      [Analytics.keys.eventAction(0)]: 'Success',
      [Analytics.keys.eventType(1)]: 'FinanceApproval',
    }
    const specificSuccessData = {
      [Analytics.keys.eventAction(1)]: 'Success',
    }
    const specificFailedData = {
      [Analytics.keys.eventAction(1)]: 'Failed',
      [Analytics.keys.eventType(2)]: 'Product journey',
      [Analytics.keys.eventAction(2)]: 'End',
    }
    pageData = wasApproved
      ? {...pageData, ...specificSuccessData}
      : {...pageData, ...specificFailedData}
    if (wasApproved) {
      setActualPage('Credit check success')
    } else {
      setActualPage('Credit check failed')
    }
      return pageData
  }

  const trackPage = () => {
    setTimeout(() => {
      const pageData = setSpecificTrackingData()
      Analytics.setTrackingData({...defaultTrackingData, ...pageData})
      Analytics.trackPage()
    }, 1000)
  }

  const trackButton = () => {
    if (!wasApproved) {
      trackInteractionSuccess('Back to HeyCar', defaultTrackingData)
    }
  }

  useEffect(() => {
    setDefaultTrackingData()
    trackPage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const ownSuccess = () => {
    trackButton()
    if (onSuccess) {
      onSuccess()
    }
  }

  return (
    <ContentSection pageWrap>
      <SectionHeading level="1" className="u-text-center" primary center>
        {Output.resolve(texts.title)}
      </SectionHeading>

      {wasApproved && (
        <Paragraph className="u-text-center">
          <Icon icon="semantic-checkmark" size={IconSize.XxLarge} />
        </Paragraph>
      )}
      <Paragraph
        className="u-text-center"
        dangerouslySetInnerHTML={{ __html: Output.resolve(texts.details) }}
      />
      <Paragraph
        className="u-text-center"
        dangerouslySetInnerHTML={{ __html: Output.resolve(texts.whatsNext) }}
      />

      <Paragraph className="u-text-center u-mt-xlarge">
        <Button
          testId="continueToStorefrontButton"
          onClick={ownSuccess}
        >
          {Output.resolve(`${texts}.${originSystem}.continueButton`)}
        </Button>
      </Paragraph>
    </ContentSection>
  );
};

export { CreditResultPage };
